import OpenService from './OpenService'

export default {
  OpenService
}